import { FunctionComponent, useEffect, useState } from "react"
import React from "react"
import { Button, Card, Col, Divider, Space, Spin } from "antd"
import { Link } from "react-router"
import { InstrumentsService } from "../api/services.gen"
import { InstrumentSearch } from "../components/instrumentSearch"

interface InstrumentsPageProps {
}

const InstrumentsPage: FunctionComponent<InstrumentsPageProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [stats, setStats] = useState<any>(undefined)

  const fetchInstruments = async () => {
    setLoading(true)
    try {
      const statistics = await InstrumentsService.getInstrumentsStatistics()
      setStats(statistics)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchInstruments()
  }, [])

  if (loading) {
    return <>
      <h2>Instruments</h2>
      <Space>
        <Spin />
      </Space>
    </>
  }
  
  return <>
    <h2>Instruments</h2>
    <Space direction="vertical" style={{ width: '100%' }}>
      <Col>
        <h3>Total: {stats?.total}</h3>
        {stats && stats.counts && (
          <Card title="Statistics" style={{ marginBottom: 16 }}>
            {Object.entries(stats.counts).map(([type, count]) => (
              <div key={type}>
                <b>{type}:</b> {String(count)}
              </div>
            ))}
          </Card>
        )}
        <Link to="/instruments/merge"><Button>Find duplicates to merge</Button></Link>
        <h3>Search instruments</h3>
        <InstrumentSearch />
        <Divider />
      </Col>
    </Space>
  </>
}


export { InstrumentsPage }